export default {
  siteName: "AllChinaBuy Spreadsheet",
  siteTagline: "Find bedre produkter, sammenlign muligheder og shop klogere",
  navHome: "Hjem",
  navCategories: "Kategorier",
  navGuides: "Guides",
  navShipping: "Forsendelse",
  navReviews: "Anmeldelser",
  navSafety: "Sikkerhed",
  navComparisons: "Sammenligninger",
  navBlog: "Blog",
  navFaq: "FAQ",
  navAbout: "Om",
  navContact: "Kontakt",
  navProducts: "Produkter",
  ctaMain: "Udforsk Spreadsheet",
  ctaBuyNow: "Køb nu",
  ctaGuide: "Læs guiden",
  ctaVisitMain: "Besøg hovedwebstedet",
  trustIndependent: "Uafhængig ressource",
  trustUpdated: "Opdaterede guides",
  trustLanguages: "4 Sprog",
  heroTitle: "AllChinaBuy Spreadsheet — Find bedre produkter, sammenlign muligheder og shop klogere",
  heroSubtitle: "Udforsk AllChinaBuy spreadsheet ressourcer, produktfund, sælger guides, QC tips, forsendelsesinformation, anmeldelser og praktiske købsråd — alt på ét sted.",
  heroCtaPrimary: "Udforsk AllChinaBuy Spreadsheet",
  heroCtaSecondary: "Start begynderguiden",
  sectionWhatIs: "Hvad er AllChinaBuy Spreadsheet?",
  sectionWhatIsDesc: "AllChinaBuy spreadsheet er en kurateret ressource, der hjælper shoppere med at opdage kvalitetsprodukter, sammenligne sælgere og træffe informerede købsbeslutninger. Det samler produktfund, anmeldelser og købstips i ét organiseret hub.",
  sectionCategories: "Populære Spreadsheet Kategorier",
  sectionHowItWorks: "Sådan fungerer Spreadsheet",
  sectionHowItWorksStep1: "Gennemse kategorier eller søg efter produkter",
  sectionHowItWorksStep2: "Sammenlign sælgere, priser og QC detaljer",
  sectionHowItWorksStep3: "Følg købsguides og sikkerhedstips",
  sectionHowItWorksStep4: "Køb sikkert gennem pålidelige links",
  sectionReview: "AllChinaBuy Anmeldelse",
  sectionReviewDesc: "En uafhængig, ærlig anmeldelse af AllChinaBuy platformen dækkende forsendelse, QC, gebyrer, lager services og samlet brugeroplevelse. Opdateret regelmæssigt med reelle indsigter.",
  sectionShipping: "Forsendelsesomkostningsguide",
  sectionShippingDesc: "Forstå hvordan forsendelsesomkostninger beregnes baseret på vægt, destination, pakkestørrelse, forsendelseslinje og sæsonmæssige faktorer. Lær hvordan du sparer på forsendelse med konsolidering og forsikringsmuligheder.",
  sectionWarehouse: "Lager & QC",
  sectionWarehouseDesc: "Lær hvordan AllChinaBuy lagerprocessen fungerer: fra sælger levering til QC inspektion, godkendelse, konsolidering og endelig pakke forsendelse. Væsentlig viden for enhver køber.",
  sectionSafety: "Sikkerhedscenter",
  sectionSafetyDesc: "Verificer URLs, tjek sælger ratings, inspektér QC billeder og følg sikre betalingspraksisser. Vores sikkerhedsguides hjælper dig med at undgå svindel og shoppe med tillid.",
  sectionComparison: "AllChinaBuy vs Konkurrenter",
  sectionComparisonDesc: "Sammenlign AllChinaBuy med Superbuy, CSSBuy og Sugargoo. Se forskellene i gebyrer, forsendelse, QC, lager services og brugeroplevelse for at finde den bedste agent til dine behov.",
  sectionArticles: "Seneste guides og artikler",
  sectionFaq: "Ofte stillede spørgsmål",
  finalCtaTitle: "Klar til at udforske AllChinaBuy spreadsheet?",
  finalCtaDesc: "Start med de seneste spreadsheet ressourcer, guides og købsinformation.",
  footerAbout: "Om",
  footerPolicy: "Redaktionel politik",
  footerDisclaimer: "Ansvarsfraskrivelse",
  footerPrivacy: "Privatlivspolitik",
  footerTerms: "Vilkår",
  footerContact: "Kontakt",
  readMore: "Læs mere",
  learnMore: "Lær mere",
  lastUpdated: "Sidst opdateret",
  relatedArticles: "Relaterede artikler",
  tableFeature: "Funktion",
  tableAllChinaBuy: "AllChinaBuy",
  tableSuperbuy: "Superbuy",
  tableCSSBuy: "CSSBuy",
  tableSugargoo: "Sugargoo",
  categoryShoes: "Sko",
  categorySneakers: "Sneakers",
  categoryHoodies: "Hættetrøjer/Sweatre",
  categoryTShirts: "T-Shirts",
  categoryJackets: "Jakker",
  categoryPants: "Bukser/Shorts",
  categoryHeadwear: "Hovedbeklædning",
  categorySets: "Sæt",
  categoryUnderwear: "Undertøj",
  categoryJersey: "Trøjer",
  categoryAccessories: "Tilbehør",
  categoryBags: "Tasker",
  categoryBelts: "Bælter",
  categoryPerfumes: "Parfumer",
  categoryOther: "Andet",
  articleTitle1: "AllChinaBuy Spreadsheet Guide 2026: Sådan finder du de bedste produkter",
  articleDesc1: "En komplet guide til at navigere i AllChinaBuy spreadsheet, forstå kategorier og finde kvalitetsprodukter med verificerede sælgere og QC tips.",
  articleTitle2: "Er AllChinaBuy legitim? Komplet sikkerheds- og tillidsguide",
  articleDesc2: "En uafhængig vurdering af AllChinaBuy's legitimitet, sikkerhedspraksisser, betalingsbeskyttelse og hvordan man undgår almindelige købsfejl.",
  articleTitle3: "AllChinaBuy vs Superbuy: Hvilken agent skal du vælge?",
  articleDesc3: "En detaljeret sammenligning af AllChinaBuy og Superbuy dækkende gebyrer, forsendelse, QC, lager services og samlet brugeroplevelse.",
  faq1Q: "Hvad er AllChinaBuy spreadsheet?",
  faq1A: "AllChinaBuy spreadsheet er en kurateret samling af produktfund, sælgerinformation og købstips organiseret efter kategori. Det hjælper shoppere med at opdage kvalitetsartikler og sammenligne muligheder før køb.",
  faq2Q: "Er AllChinaBuy sikker at bruge?",
  faq2A: "AllChinaBuy er en legitim indkøbsagent platform. Som ethvert internationalt indkøbs service, bør købere følge sikkerhedspraksisser: verificer sælger ratings, tjek QC billeder, brug sikre betalingsmetoder og læs anmeldelser før køb.",
  faq3Q: "Hvordan fungerer forsendelse med AllChinaBuy?",
  faq3A: "AllChinaBuy tilbyder flere forsendelseslinjer baseret på destination, vægt og pakkestørrelse. Omkostninger afhænger af faktisk eller volumetrisk vægt, destinationsland og valgt forsendelsesmetode. Konsolidering og forsikringsmuligheder er tilgængelige.",
  faq4Q: "Kan jeg stole på spreadsheet produktanbefalingerne?",
  faq4A: "Spreadsheet er en uafhængig ressource, der samler community fund og anmeldelser. Selvom vi verificerer information så godt vi kan, skal du altid udføre dine egne QC kontroller og læse sælger anmeldelser før køb.",
  faq5Q: "Hvad er QC og hvorfor er det vigtigt?",
  faq5A: "QC (kvalitetskontrol) er inspektionsprocessen hvor lagerpersonale tjekker dine varer for defekter, størrelsesproblemer eller forkerte produkter før forsendelse. Det er afgørende for at fange problemer tidligt og anmode om udskiftninger eller refusion.",
  pageNotFound: "Side ikke fundet",
  pageNotFoundDesc: "Siden du leder efter findes ikke. Gå tilbage til hjemmesiden for at udforske AllChinaBuy spreadsheet ressourcer.",
  backToHome: "Tilbage til hjem",
  allchinabuySpreadsheet: "AllChinaBuy Spreadsheet",
  spreadsheetHub: "Spreadsheet Hub",
  comparison: "Sammenligning",
  warehouse: "Lager",
  review: "Anmeldelse",
  coupon: "Kupon",
  discountCode: "Rabatkode",
  legit: "Legitim",
  shippingCost: "Forsendelsesomkostning",
  beginnersGuide: "Begynderguide",
  qcGuide: "QC Guide",
  sellerGuide: "Sælger Guide",
  buyingChecklist: "Købs Checkliste",
  productVerification: "Produktverifikation",
  safetyCenter: "Sikkerhedscenter",
  paymentSafety: "Betalingssikkerhed",
  sellerSafety: "Sælger Sikkerhed",
  qcSafety: "QC Sikkerhed",
  shippingSafety: "Forsendelsessikkerhed",
  scamWarning: "Svindel Advarsel",
  alternatives: "Alternativer",
  vsSuperbuy: "AllChinaBuy vs Superbuy",
  vsCSSBuy: "AllChinaBuy vs CSSBuy",
  vsSugargoo: "AllChinaBuy vs Sugargoo",
  languageEnglish: "Engelsk",
  languageFrench: "Fransk",
  languageDanish: "Dansk",
  languageGerman: "Tysk",
  breadcrumbHome: "Hjem",
  editorialTitle: "Redaktionel politik",
  editorialDesc: "Dette websted leverer uafhængige pædagogiske oplysninger og er ikke tilknyttet AllChinaBuy. Vi garanterer ikke produktkvalitet, sælger pålidelighed eller forsendelsesresultater. Verificer altid information uafhængigt.",
  cookieNotice: "Vi bruger cookies for at forbedre din oplevelse. Ved at fortsætte accepterer du vores brug af cookies.",
  cookieAccept: "Accepter",
  productsTitle: "Produktkatalog",
  productsSubtitle: "Gennemse vores kuraterede samling af verificerede produkter fra AllChinaBuy spreadsheet. Klik på et element for at se detaljer og købe.",
  productsSearchPlaceholder: "Søg efter produkter...",
  allCategories: "Alle",
  noProductsFound: "Ingen produkter fundet.",
  buyNow: "Køb nu",
};